<script lang="ts">
  import RetryModal from './RetryModal.svelte'
  import { onDestroy, onMount } from 'svelte'
  import Portal from 'svelte-portal'

  let {
    contactImports = []
  } = $props()

  let showingRetry = $state(false)
  let currentImport = $state(null)

  onMount(() => {
    App.subscribe("account.contact_imports.updated", contactImportUpdated)
  })

  onDestroy(() => {
    App.unsubscribe("account.contact_imports.updated", contactImportUpdated)
  })

  // TODO listen to event-bus pushes for updated progress,
  // update that specific model in the data

  function contactImportUpdated(evt) {
    let updatedContactImport = evt.detail.contact_import
    let index = contactImports.findIndex(imp => imp.to_param === updatedContactImport.to_param)
    let newImports = contactImports
    newImports.splice(index, 1, updatedContactImport)
    contactImports = newImports
  }

  function showRetry(hashid) {
    currentImport = contactImports.find(ci => ci.to_param == hashid)
    showingRetry = true
  }

  function hideRetry() {
    currentImport = null
    showingRetry = false
  }
</script>

<div class="ContactImportsIndex">
  <Portal target="#cta-portal">
    <a href="/contact_imports/new" class="btn btn-success btn-rounded">Start a new Contact Import</a>
  </Portal>

  <div class="panel panel--settings mt-2">
    {#if !contactImports.length}
      <div class="text-center">
        <h3>Nothing here yet.</h3>
        <h3>
          <a href="/contact_imports/new">Start a new contact import?</a>
        </h3>
      </div>
    {:else}
      <div class="index-count">
        {contactImports.length}
        <div class="index-count--name">Contact Imports</div>
      </div>
      <div class="well well-table">
        <table class="table table-striped table-bordered">
          <thead>
          <tr>
            <th>Uploaded File</th>
            <th>Created</th>
            <th>Import Totals</th>
            <th>Status</th>
            <th style="width: 1%"></th>
          </tr>
          </thead>
          <tbody>
          {#each contactImports as contactImport (contactImport.to_param)}
            <tr>
              <td>
                <a href="/contact_imports/{contactImport.to_param}">
                  {contactImport.filename || '[no file name]'}
                </a>
              </td>
              <td>
                <a href="/contact_imports/{contactImport.to_param}">
                  {new Date(contactImport.created_at).toLocaleDateString()}
                </a>
              </td>
              <td>
                <div>
                  {contactImport.meta.contacts_invited} Invited of
                  {contactImport.meta.contacts_created} Total
                </div>
              </td>
              <td>
                <p>{contactImport.status}</p>
                <div class="progress">
                  <div
                    aria-valuemax="100"
                    aria-valuemin="0"
                    aria-valuenow={contactImport.percent_complete}
                    class="progress-bar progress-bar-success"
                    role="progressbar"
                    style="width: {contactImport.percent_complete}%"
                  >{Math.round(contactImport.percent_complete)}%
                  </div>
                </div>
              </td>
              <td style="vertical-align: middle; padding-right: 2em">
                <button
                  class:d-none={!contactImport.retryable}
                  class="btn btn-white"
                  onclick={() => showRetry(contactImport.to_param)}
                >Retry
                </button>
              </td>
            </tr>
          {/each}
          </tbody>
        </table>
      </div>
    {/if}
  </div>

  <RetryModal
    showing={showingRetry}
    contactImport={currentImport}
    onClose={hideRetry}
  />
</div>
